import EnquiryScreen from '../screens/enquiry'

export default EnquiryScreen
